/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { executeHttpRequest } from '../../epics/api';
import { getErrorMessages } from '../../utils';


type TFreelancerDetailsWorkHistory = {
    freelancerId: number;
};
type TWorkHistoryRecord = {
    id: number;
    freelancer: number;
    from_date: string;
    is_current_position: boolean;
    to_date: string;
    salary: number;
    company_name: string;
    address: string;
    contact_person: string;
    contact_phone: string;
    contact_email: string;
    job_title: string;
    reason_for_leaving: string;
    agency_name: string;
}

export default function FreelancerDetailsWorkHistory({
    freelancerId,
}: TFreelancerDetailsWorkHistory) {
    const [workHistoryRecords, setWorkHistoryRecords]  = useState<TWorkHistoryRecord[]>();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        executeHttpRequest(`freelancers/${freelancerId}/work-history/`)
            .then((response => {
                setIsLoading(false);
                setWorkHistoryRecords(response.data.content);
            }))
            .catch(err => {
                setIsLoading(false);
                setError(getErrorMessages(err));
            });
    }, [freelancerId]);

    const renderRows = () =>
        workHistoryRecords?.map((record: TWorkHistoryRecord) => {
            const fromDate = moment(record.from_date).format('DD/MM/YYYY');
            const toDate = record.to_date
                ? moment(record.to_date).format('DD/MM/YYYY')
                : 'present';
            return (
                <tr key={`whr-${record.id}`} style={{ lineBreak: 'auto' }}>
                    <td>{fromDate} - {toDate}</td>
                    <td>{record.salary}</td>
                    <td>{record.company_name}</td>
                    <td>{record.address}</td>
                    <td>
                        {record.contact_person}<br/>
                        {record.contact_phone}<br/>
                        {record.contact_email}
                    </td>
                    <td>{record.job_title}</td>
                    <td>{record.reason_for_leaving}</td>
                    <td>{record.agency_name}</td>
                </tr>
            );
        });



    return (
        <div className="freelancer-details-section">
            <div className="freelancer-details-section__header">
                <div className="freelancer-details-section__title">Employment / Work history</div>
                {isLoading && (
                    <i className="icon icon-loading-1 font-size-30" />
                )}
            </div>
            <div className="freelancer-details-section__content">
                {!!error &&
                    <div className="freelancer-details-section__errors">
                        <p>{error}</p>
                    </div>
                }
                {workHistoryRecords?.length === 0 ? (
                    <div>Worker doesn&apos;t have any work history yet.</div>
                ) : (
                    <table className="table-default">
                        <tbody>
                            <tr>
                                <td className="table-default__cell--text-blue">
                                    Dates
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Salary
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Company
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Address
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Contact
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Job title
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Reason for leaving
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Agency
                                </td>
                            </tr>
                            {renderRows()}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
